<template>
  <div class="accordion-modal box" :class="{'anchorDisplay': anchorDisplay}">
    <button
      @click="collapsed = !collapsed"
      class="btn-accordion"
      :aria-controls="idAccordion"
      :aria-expanded="!collapsed">
      <span>{{ serviceName }}</span>
      <span class="number-services">{{ `${numberService} SERVICE${numberService> 1? 'S':''}` }}</span>
    </button>
      <div :id="idAccordion" :class="{ collapsed }"  class="collapse-container">
        <div
          v-for="mode in allMode"
          :key="mode + serviceName"
        >
          <h3 class="service-mode">{{ capitalizeFirstLetter(mode) }}</h3>
          <ul class="resetul list-cards-services">
            <ServiceDetails
              v-for="(serviceDetails, idx) in services.getServiceContentByNameAndMode(
                      serviceName,
                      mode
                    )"
              :serviceDetails="serviceDetails"
              :key="serviceDetails.getName() + idx"
              :serviceName="serviceName"
            />
          </ul>
        </div>

      </div>
  </div>
</template>

<script>
import { inject, ref, onMounted } from 'vue';
import ServiceDetails from '@/components/phoneBook/servicesContent/servicesContentComponents/ServiceDetails.component.vue';
import { hashGenerator, capitalizeFirstLetter, debounce } from '@/helpers';

export default {
  components: {
    ServiceDetails,
  },
  props: {
    serviceName: { type: String, default: '' },
    allMode: { type: Object },
    numberService: { type: Number, default: 0 },
    anchorDisplay: { type: Boolean, default: false },
  },
  setup(props) {
    const idAccordion = hashGenerator();
    const services = inject('services');
    const collapsed = ref(!props.anchorDisplay);

    const scrollToBloc = debounce(() => {
      const elementToScrollTo = document.querySelector('.anchorDisplay');
      if (collapsed.value && elementToScrollTo) {
        elementToScrollTo.scrollIntoView(collapsed);
      }
    }, 500);

    onMounted(() => {
      scrollToBloc();
    });
    return {
      idAccordion,
      services,
      collapsed,
      capitalizeFirstLetter,
    };
  },
};
</script>
